import classNames from 'classnames';

import { PILL_TOGGLE_VARIANT_CLASSES } from './pill-toggle.styles';
import { PillToggleProps, SIZE_L, SIZE_S } from './pill-toggle.type';

export const PillToggle = ({
  variant,
  label,
  size = SIZE_L,
  disabled = false,
  indicator,
  fullWidth = false,
  textClassName = 'text-subtitle-m',
  className,
}: PillToggleProps) => (
  <span
    className={classNames(
      'inline-flex items-center justify-center gap-1 rounded-[5px]',
      textClassName,
      PILL_TOGGLE_VARIANT_CLASSES[variant],
      {
        'h-9': size === SIZE_S,
        'h-[42px]': size === SIZE_L,
        'opacity-50': disabled,
        'w-full min-w-0 px-1 xs:px-3': fullWidth,
        'px-3': !fullWidth,
      },
      className
    )}>
    {fullWidth ? <span className='truncate'>{label}</span> : label}
    {indicator}
  </span>
);
